<script>
import VueUtils from '@/utils/vueUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'

export default
{
    name: 'alert-bubble',

    props:
    {
        alertId: {type: String}
    },

    created ()
    {
    },

    render () 
    {
        return (
            <div class='alert-bubble'>
                <inline-svg class='icon' src={require('@/assets/img/question-mark-circle.svg')} />
                <div class='text'>{this.$slots.default}</div>
                <inline-svg class='close-btn' src={require('@/assets/img/cross.svg')} on-click={this.onCloseButtonClicked} />
            </div>
        )
    },

    mounted ()
    {
        if (this.alertId && LocalStorageUtils.closedAlertIds.includes(this.alertId))
        {
            VueUtils.destroyInstance(this)
        }
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
    },

    methods:
    {
        onCloseButtonClicked ()
        {
            if (this.alertId && !LocalStorageUtils.closedAlertIds.includes(this.alertId))
            {
                LocalStorageUtils.closedAlertIds = [...LocalStorageUtils.closedAlertIds, this.alertId]
            }
            VueUtils.destroyInstance(this)
        }
    },

    components:
    {
    }
}
</script>

<style lang='less'>
.alert-bubble
{
    width: -webkit-fill-available;
    padding: 12px 15px;
    margin-bottom: 15px;
    background-color: var(--theme-content-background-color);
    border-radius: 13px;
    font-size: 13px;
    display: flex;
    flex-direction: row;

    .icon
    {
        width: 69px;
        height: fit-content;
        height: intrinsic;
        min-width: 20px;
        min-height: 20px;
        margin-right: 15px;
        margin-left: 3px;
        fill: var(--theme-background-text-color);
        align-self: baseline;
    }

    .text
    {
        min-width: 83%;
        height: fit-content;
        margin: auto;
    }

    .close-btn
    {
        width: 25px;
        height: fit-content;
        height: intrinsic;
        min-width: 10px;
        min-height: 10px;
        margin-left: 8px;
        fill: var(--theme-background-text-color);
        cursor: pointer;

        &:hover
        {
            fill: var(--theme-background-text-color-heavy);
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/AlertBubble.vue